import * as React from 'react';
import type { Props } from '../HybridLink/HybridLink';
import HybridLink from '../HybridLink/HybridLink';
import cn from '~modules/cn';
import Styles from './text-link.module.scss';

const TextLink = React.forwardRef<HTMLElement, Props>((props, ref) => (
    <HybridLink {...props} className={cn(Styles.link, props.className)} setRef={ref as React.RefObject<$TSFixMe>} />
));

TextLink.displayName = 'TextLink';

export default TextLink;
